/// <reference path="medical-alert-type.model.ts" />
import { IncidentModel } from './incident.model';
import { MedicalAlertType } from './medical-alert-type.model';
export class IncidentMedicalAlertModel extends IncidentModel {

    public medicalAlertTypes: MedicalAlertType[] = [];
    public cdlHolderIndicator = false;
    public commercialMotorVehicleIndicator = false;
    public hazardousMaterialIndicator = false;
    public passengerIndicator = false;
    public driverLicenseNumber: string;
    public driverLicenseJurisdictionId: number;
}
